import React, { useRef, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import StopStepper from './StopStepper';
import Button from '@material-ui/core/Button';
import Header from './Header';
import { ACTIVE_DETAILS } from '../../constants';
import { isDeliveryOrPickup, isNotDelayStop } from '../../Utils';

const styles = (theme) => ({
  root: {
    width: '98%',
    height: '70%'
  },
  buttonClass: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  countLabel: {
    marginTop: 8,
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 500
  },
  buttonStyle: {
    '&$disabledButton,&$disabledButton:hover': {
      cursor: 'not-allowed',
      pointerEvents: 'all',
      backgroundColor: theme.customInputBGColor,
      color: theme.white
    }
  },
  marginLeft: {
    marginLeft: 10
  },

  disabledButton: {
    cursor: 'not-allowed',
    pointerEvents: 'all',
    backgroundColor: theme.iconColor,
    color: theme.white
  }
});

const StopList = (props) => {
  const pickupDeliveryStops = props.stops.filter(stop=> isDeliveryOrPickup(stop.stopType));
  const filterStops = props.stops.filter(stop=>isNotDelayStop(stop.stopType));
  const stepRef = useRef(null);
  const handleNext = () => {
    const step = props.selectedStopIndex + 1;
    props.onStopSelectionChange(step);
    scrollToSelectedDrawingCard(step);
  };

  const handleBack = () => {
    const step = props.selectedStopIndex - 1;
    props.onStopSelectionChange(step);
    scrollToSelectedDrawingCard(step);
  };

  const scrollToSelectedDrawingCard = (id) => {
    let matchedRef;
    stepRef?.current?.childNodes[0]?.childNodes?.forEach((node) => {
      if (node.id === `stopStep-${id}`) {
        matchedRef = node;
      }
    });

    matchedRef?.scrollIntoView({
      block: 'center', //'nearest': The element will be aligned to the closest edge of the scrollable container.
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    scrollToSelectedDrawingCard(selectedStopIndex);
  }, []);

  const { classes, stops, activeDetail, selectedStopIndex, driverData, route } = props;
  return (
    <div className={classes.root}>
      <Header {...props} />
      <StopStepper
        steps={stops}
        activeStep={selectedStopIndex}
        activeDetail={activeDetail}
        onStopSelectionChange={props.onStopSelectionChange}
        stepRef={stepRef}
        isLiveDispatch={driverData.isLiveDispatch}
        route={route}
      />
      {(activeDetail === ACTIVE_DETAILS.STOP && stops.length > 0) ||
      activeDetail === ACTIVE_DETAILS.ROUTE_COMPLIANCE ? (
        <div className={classes.countLabel}>{`${pickupDeliveryStops.length} Total Stops`}</div>
      ) : null}
      {activeDetail === ACTIVE_DETAILS.STOP && stops.length > 0 ? (
        <div className={classes.buttonClass}>
          <Button
            disabled={selectedStopIndex === 1}
            onClick={handleBack}
            classes={{ root: classes.buttonStyle, disabled: classes.disabledButton }}
            variant="outlined"
            color="primary">
            Previous Stop
          </Button>
          <Button
            variant="contained"
            color="primary"
            classes={{ root: classes.buttonStyle, disabled: classes.disabledButton }}
            className={classes.marginLeft}
            disabled={selectedStopIndex === filterStops.length}
            onClick={handleNext}>
            Next Stop
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(StopList);
